module.exports = __webpack_public_path__ + "images/videoCaseStudy-mandel-whyus-photo-02.jpg?h=fece21cbd8aaf1a514e3a10fa7300eb9";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/mandel/videoCaseStudy-mandel-whyus-photo-02.jpg
// module id = 2109
// module chunks = 12 15